import clientSDK from '../../../App/ClientSDK'
import { IDevice, IApiDevice, IDeviceListResponse } from '../IDevice'

const baseUrl = 'calendar/devices'

const deviceApiTransformer = (data: IApiDevice): IDevice => data

const getList = async () => {
  const response = await clientSDK.instance().get<IDeviceListResponse>(baseUrl)
  const data = response.data
  return data.list
    .filter((device: IApiDevice) => !device.is_deleted)
    .map(device => deviceApiTransformer(device))
}

const useDeviceService = {
  getList,
}

export default useDeviceService
